/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import classnames from 'classnames';
import _ from 'lodash';

import {
  Intl, Form, TextField, Select, Phone, ChangePasswordModal,
  FormItemRow, FormActionsBtns, ModalForm, Checkbox,
} from 'components';
import {
  composeValidators, email, required, validPhone, validPhoneCountry,
} from 'config/InputErrors';

export default ( {
  entityId, data, history, isLoading, parentPath, onSubmit, userData,
} ) => {
  const [changePasswordModal, setChangePasswordModal] = useState( false );
  const [visibleLegalPhoneModal, setVisibleLegalPhoneModal] = useState( false );
  const [dataPhone, setDataPhone] = useState( {} );
  const [dataInitial, setDataInitial] = useState( {} );

  const toggleChangePasswordModal = useCallback( () => {
    setChangePasswordModal( ( state ) => !state );
  }, [] );

  useEffect( () => {
    setDataInitial( { ...data, ...dataPhone } );
  }, [data, dataPhone, setDataInitial] );

  return (
    <Container
      fluid
      className={classnames( { 'app-component-loading': isLoading } )}
    >
      <Form
        initialValues={dataInitial}
        showErrorsInHeader
        onSubmit={onSubmit}
        keepDirtyOnReinitialize
        body={(form) => {
          const formValues = form.getState().values || {};
          return (
          <>
            <Row className="mb-1">
              <Col>
                {( data.id || !entityId )
                  ? (
                    <Intl
                      // eslint-disable-next-line no-nested-ternary
                      id={entityId ? _.indexOf( data.roles, 'ROLE_CUSTOMER_ADMIN' ) !== -1 ? 'administrator' : 'user' : 'newUser'}
                    />
                  )
                  : <p />}
              </Col>
            </Row>
            <FormItemRow
              title="firstName"
              field={(
                <TextField
                  field="firstName"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="lastName"
              field={(
                <TextField
                  field="lastName"
                  formGroupClass="m-0"
                  validate={required}
                />
              )}
            />
            <FormItemRow
              title="userEmail"
              field={(
                <TextField
                  field="email"
                  formGroupClass="m-0"
                  validate={composeValidators( required, email )}
                  // disabled={formValues.id == userData.id}
                  disabled={formValues.id != undefined}
                />
              )}
            />
            <FormItemRow
              title="userSenderPhone"
              field={(
                <Row noGutters>
                  <Col xs={9}>
                    <TextField
                      field="phone"
                      formGroupClass="m-0"
                      placeholder="pulseEditPhone"
                      validate={composeValidators( required )}
                      disabled
                    />
                  </Col>
                  <Col xs={3} className="pl-2">
                    <Button
                      color="app-default"
                      size="app-sm"
                      className="font-weight-700"
                      type="button"
                      block
                      onClick={() => {
                        setVisibleLegalPhoneModal( true );
                      }}
                    >
                      <Intl id="edit" />
                    </Button>
                  </Col>
                </Row>
              )}
            />
            <FormItemRow
              title="language"
              fieldSize={2}
              field={(
                <Select
                  field="language"
                  formGroupClass="m-0"
                  translateOptions
                  options={[
                    { id: 'es', name: 'spanishOptions' },
                    { id: 'en', name: 'englishOption' },
                  ]}
                  validate={required}
                />
              )}
            />
            {!!entityId
            && (
              <Row>
                <Col md={3} className="pr-0">
                  <Button
                    color="app-default"
                    size="app-sm"
                    className="font-weight-700"
                    type="button"
                    block
                    onClick={toggleChangePasswordModal}
                  >
                    <Intl id="changePassword" />
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}}
        footer={( <FormActionsBtns saveLabel="save" cancelTo={parentPath} /> )}
      />

      {changePasswordModal
      && (
        <ChangePasswordModal
          entityId={entityId}
          open={changePasswordModal}
          onClose={toggleChangePasswordModal}
          onConfirm={() => history.push( parentPath )}
        />
      )}

      <ModalForm
        title="legalPhoneTitle"
        open={visibleLegalPhoneModal}
        size="lg"
        onClose={() => {
          setVisibleLegalPhoneModal( false );
        }}
        onSubmit={( dataLegalPhone ) => {
          // eslint-disable-next-line no-param-reassign
          delete dataLegalPhone.legalPhone;
          setDataPhone( dataLegalPhone ); setVisibleLegalPhoneModal( false );
        }}
        footer={(
          <FormActionsBtns
            saveLabel="okBtn"
          />
        )}
        initialValues={dataInitial}
        body={() => (
          <>
            <FormItemRow
              title="userSenderPhone"
              className="mt-3"
              field={(
                <Phone
                  field="phone"
                  formGroupClass="m-0"
                  validate={composeValidators( required, validPhone, validPhoneCountry )}
                />
              )}
            />
            <Row className="mt-3">
              <Col>
                <Checkbox
                  field="legalPhone"
                  translateLabel={false}
                  validate={required}
                  label={(
                    <Intl id="legalPhoneText" />
                  )}
                />
              </Col>
            </Row>
          </>
        )}
      />
    </Container>
  );
};
